// extracted by mini-css-extract-plugin
module.exports = {"team-matches-section":"team-matches-section","group-matches":"group-matches"};